// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__ng1Lb","item":"styles_item__2ZJlh","active":"styles_active__XFTjO"};